import { useContext, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router'
import { connect } from 'react-redux'
import { LoginService } from './services/login.service'
import setLogged from '../../redux/actions/logged/setLogged'
import SnackBarUtils from '../../utils/SnackBarUtils'
import { Box, Container, Paper, useMediaQuery, useTheme } from '@mui/material'
import Form from './components/Form'
import RecuperarPassword from './RecuperarPassword/RecuperarPassword'
import { RolType } from '../../components/Navbar/Sidebar/SidebarItems'
import Footer from '../Home/components/Footer'
import { TenantsContext } from '../../context/tenants.context'
import logOut from '../../redux/actions/logged/logOut'
import { confirmarTenantLocal } from '../Products/services/locals.services'
import { useAppStore } from '../../store/app-store'
import { useAnalytics } from '../../hooks/useAnalytics'
import DialogComprador from './DialogComprador'

const LoginPage = (props: any) => {
  const { userLogged } = props.logged
  const setCodLocal = useAppStore((state) => state.setCodLocal)
  const navigate = useNavigate()
  const location = useLocation()
  const [loading, setLoading] = useState(false)
  const [token, setToken] = useState('')
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const [recuperarPass, setRecuperarPass] = useState(false)
  const [openComprador, setOpenComprador] = useState<boolean>(false)
  const { tenant, domain } = useContext(TenantsContext)
  const { track, setUser } = useAnalytics()

  const confirmDataLocal = (dataLogin: any) => {
    setLoading(true)
    confirmarTenantLocal(dataLogin.codLocal, dataLogin.accessToken, tenant)
      .then(({ data }) => {
        if (data.data) {
          setCodLocal(dataLogin.codLocal)
          props.setLogged(dataLogin)

          // Firebase Analytics: Login exitoso de vendedor
          track('login', {
            method: 'email'
          })
          // Establecer el ID del vendedor
          if (dataLogin.user?.id) {
            setUser(dataLogin.user.id)
          }
        } else {
          SnackBarUtils.error(data.message || `Asegurate de que tu local pertenezca a ${tenant.nombrePlataforma}`)
          //navigate('/login')
        }
      })
      .catch((e) => console.log(e))
      .finally(() => {
        setLoading(false)
      })
  }

  const handleLogin = async (user: string, pwd: string) => {
    if (!user || !pwd) return SnackBarUtils.error('Completa los datos para ingresar!')
    setLoading(true)
    try {
      const loginUser = { user, pwd, captcha: token }
      const res = await LoginService(loginUser, tenant)
      if (res && res.status !== 200) {
        return SnackBarUtils.error('Usuario o contraseña incorrectos')
      }
      if (res.data.roles.includes('vendedor')) {
        confirmDataLocal(res.data)
      } else {
        props.setLogged(res.data)
      }
    } catch (e) {
      console.log(e)
      SnackBarUtils.error('Usuario o contraseña incorrectos')
    } finally {
      setLoading(false)
    }
  }

  const goToRegister = () => navigate('/abm-local')

  useEffect(() => {
    if (userLogged.isLogged) {
      if (
        userLogged.user.roles &&
        (userLogged.user.roles.includes(RolType.ADMIN) || userLogged.user.roles.includes(RolType.MOD))
      ) {
        navigate('/abm-locales')
      } else if (userLogged.user.roles?.includes(RolType.USER)) {
        navigate('/home')
      } else if (userLogged.user.roles?.includes(RolType.CLIENT)) {
        props.logOut()
        setOpenComprador(true)
        // navigate('/login')
      }
    }
  }, [userLogged, location])

  if (!tenant) return

  return (
    <>
      <Container
        sx={
          isMobile
            ? { display: 'flex' }
            : {
                display: 'flex',
                justifyContent: 'center',
                width: '100%',
                height: '100vh',
                marginBottom: '4px'
              }
        }
      >
        {isMobile ? (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px', mt: '1rem' }}>
            <img src={tenant.logo} width={isMobile ? '100%' : 600} alt="Avellaneda A 1 Toque" />

            <Form
              domain={domain}
              tenant={tenant}
              handleLogin={handleLogin}
              goToRegister={goToRegister}
              loading={loading}
              setToken={setToken}
              setRecuperarPass={setRecuperarPass}
            />
            <RecuperarPassword open={recuperarPass} setOpen={setRecuperarPass} props={props} />
          </Box>
        ) : (
          <Paper variant="outlined" sx={{ p: 3, alignSelf: 'center' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <img src={tenant.logo} width={isMobile ? '100%' : 600} alt="Avellaneda A 1 Toque" />

              <Form
                domain={domain}
                tenant={tenant}
                handleLogin={handleLogin}
                goToRegister={goToRegister}
                loading={loading}
                setToken={setToken}
                setRecuperarPass={setRecuperarPass}
              />
              <RecuperarPassword open={recuperarPass} setOpen={setRecuperarPass} props={props} />
            </Box>
          </Paper>
        )}
      </Container>
      <Footer />
      <DialogComprador open={openComprador} setOpen={setOpenComprador} />
    </>
  )
}

const mapStateToProps = (state: any) => {
  return {
    logged: state.logged
  }
}

const mapDispatchToProps = {
  setLogged,
  logOut
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage)
